import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'
import Moment from 'moment';
import {IdentifyTypes} from "../Identify/Reducer";
import {
    asMutable,
    genericDateTime, isGenderMatch,
    isSameDate,
    serverDayDate,
    toServerDate
} from "../../Common/Helpers";

import {CommonTypes} from '../../Redux/CommonTypes';
import {
    configToProgress,
    setProgressValueByKey,
} from "../../Common/redux-helper";
import {
    ANY_EMPLOYEE, ASAP,
    GENDER_TYPE,
    GENERAL_TIME_OPTIONS,
    PROGRESS_KEY,
    SIMULTANEOUS_SERVICE_SCHEDULING_TYPE,
    TIMING_FRAMES, WAITING_LIST_RANGE_MODE
} from "../../Common/constants";
import {
    cleanObj,
    isConcreteValue,
    isNonEmptyArray, isNonEmptyObject,
    isNonEmptyString, isNumber,
    valueOrDefault
} from "@tomeravni/easybizy-js-common/common";

const DEFAULT_DAY_PART = '111';

const {Types} = createActions({
    setStateParams: ['token', 'service_id', 'employee_id', 'day_part',
        'date', 'mobile', 'email', 'validation_hash', 'existing_mode', 'existing_meeting_mode',
        'existing_meeting_start_time', 'existing_meeting_id', 'quantity', 'gender', 's_category'],
    setSession: ['s_token', 'paymentUrl'],
    configRequest: [],
    configSuccess: ['config'],
    configError: ['error'],
    configWithServicesRequest: ['clearExisting'],
    configWithServicesSuccess: ['config'],
    configWithServicesError: ['error'],
    setServices: ['services'],
    setEmployee: ['employee'],
    toggleDayPart: ['option'],
    setDateOption: ['option', 'date'],
    alignDayParts: ['dayParts'],
    instantOptionsRequest: ['serviceId', 'employeeId'],
    instantOptionsSuccess: ['options'],
    instantOptionsError: ['error'],
    specificOptionsRequest: ['serviceId', 'employeeId', 'dayPart', 'date'],
    specificOptionsSuccess: ['options'],
    specificOptionsError: ['error'],
    optionsErrorClear: [],
    // Scheduling
    scheduleMeetingRequest: [],
    scheduleMeetingSuccess: ['scheduledMeetings', 'paymentRequired', 'token', 'url'],
    scheduleMeetingError: ['error'],
    // Scheduling
    removeMeetingsRequest: [],
    removeMeetingsSuccess: [],
    removeMeetingsError: ['error'],
    // Existing mode.
    setExistingMeetingsGroupMode: ['mode', 'group'],
    clearExistingMeetingsMode: [],
    /// Item quantity
    changeItemQuantity: ['item', 'addition', 'simultaneousType'],
    changeItemGender: ['item', 'index', 'quantity'],
    /// Service Category
    selectServiceCategory: ['category'],
    // Session
    getSessionRequest: ['token'],
    getSessionSuccess: ['scheduledMeetings', 'paymentRequired', 'url', 'icsUrl', 'paymentType'],
    getSessionError: ['error'],
    cancelSessionRequest: ['token'],
    cancelSessionSuccess: [],
    cancelSessionError: ['error'],
    /// Manifest
    getManifestRequest: [],
    getManifestSuccess: ['manifest'],
    getManifestError: ['error'],
    /// Waiting List
    setWaitingListSelectedDate: ['selectedDate'],
    setWaitingListRangeType: ['rangeType'],
    setWaitingListSelectedDaysOfWeek: ['selectedDaysOfWeek'],
    registerWaitingListRequest: ['waitingListOptions'],
    registerWaitingListSuccess: ['waitingListItem'],
    registerWaitingListError: ['error'],
    removeWaitingListRequest: ['waitingListOptions'],
    removeWaitingListSuccess: [],
    removeWaitingListError: ['error'],
    setIgnoreWaitingList: [],
});


export const ScheduleTypes = Types;

/* ------------- Initial State ------------- */


export const ASAP_DATE = GENERAL_TIME_OPTIONS[0];
export const SPECIFIC_DATE = GENERAL_TIME_OPTIONS[1];

export const INITIAL_STATE = Immutable({
    // Regular config:
    fetchingConfig: false,
    errorWithConfig: null,
    config: null,
    hasOtherMeetings: false,
    // Config with services:
    fetchingServices: false,
    errorWithServices: null,
    configWithServices: null,
    // Selected values:
    services: null,
    filteredAvailableServices: null,
    resentCode: false,
    employee: null,
    // Metadata options
    availableEmployees: null,
    timingOptions: TIMING_FRAMES.slice(),
    datingOptions: GENERAL_TIME_OPTIONS.slice(),
    // INSTANT OPTIONS
    fetchingInstantOptions: false,
    errorInstantOptions: null,
    instantOptions: null,
    // SPECIFIC OPTIONS
    fetchingSpecificOptions: false,
    errorSpecificOptions: null,
    specificOptions: null,
    // SCHEDULING
    schedulingMeetings: false,
    scheduledMeeting: null,
    schedulingMeetingsError: null,
    // Quantity
    itemsQuantityMap: {},
    // Gender
    itemsGenderMap: {},
    // Service Category
    serviceCategory: null,
    // Payment Url
    paymentUrl: null,
    // Manifest
    requestingManifest: false, manifestError: null,
    icsUrl: null,
    // From server.
    userSelection: null,
    /**
     * Waiting List props.
     */
    waitingListItem: null,
    waitingListMode: null, /*This represents how aggressive the waiting list option should be presented. NONE: 'none', IMMEDIATE: 'immediate', SUGGESTION: 'suggestion' */
    waitingListRangeType: WAITING_LIST_RANGE_MODE.EXACT_DATE,
    waitingListSelectedDate: null,
    waitingListSelectedDaysOfWeek: []


});


const adaptServiceAndEmployeeToState = (state, config) => {
    let stateToReturn = state;
    if (state.stateParams.service_id && isNonEmptyArray(config.Services)) {
        if (isNonEmptyString(state.stateParams.gender)) {
            const genders = [...state.stateParams.gender.split(',')];
            const itemsGenderMap = {};
            for (const gender of genders) {
                const [id, gendersForItem] = gender.split('_');
                const gendersByIdx = gendersForItem.split('-');

                const service = config.Services.find((service) => service.OnlineBookingServiceId.toString() === id.toString());
                if (service && gendersByIdx.length > 0 && service.PickGenderCount >= 1) {
                    itemsGenderMap[service.OnlineBookingServiceId] = gendersByIdx.slice(0, service.PickGenderCount);
                }
            }

            stateToReturn = stateToReturn.merge({itemsGenderMap})
        }

        const selectedServiceIds = state.stateParams.service_id.split(',');
        const servicesToSet = [];
        for (let idx in config.Services) {
            if (selectedServiceIds.indexOf(config.Services[idx].OnlineBookingServiceId.toString()) > -1) {
                servicesToSet.push(config.Services[idx]);
            }
        }

        stateToReturn = setServices(stateToReturn, {services: servicesToSet});
    }

    if (state.stateParams.employee_id && stateToReturn.availableEmployees) {
        for (let idx in stateToReturn.availableEmployees) {
            if (stateToReturn.availableEmployees[idx].EmployeeId && (state.stateParams.employee_id.toString() === stateToReturn.availableEmployees[idx].EmployeeId.toString())) {
                stateToReturn = setEmployee(stateToReturn, {employee: stateToReturn.availableEmployees[idx]});
                break;
            }

        }
    }

    if (stateToReturn.progress && stateToReturn.stateParams.date) {
        stateToReturn = setDateOption(stateToReturn, {option: stateToReturn.stateParams.date});
    }

    if (isNonEmptyString(state.stateParams.quantities) && config.Services) {
        const quantities = [...state.stateParams.quantities.split(',')];
        const itemsQuantityMap = {};
        for (const quantity of quantities) {
            const [id, quan, simultaneousType] = quantity.split('_');
            const service = config.Services.find((service) => service.OnlineBookingServiceId.toString() === id.toString());
            if (service && quan > 1 && service.EnabledSimultaneousServicesCount > 1) {
                itemsQuantityMap[service.OnlineBookingServiceId] = `${Math.min(quan, service.EnabledSimultaneousServicesCount)}_${simultaneousType}`;
            }
        }

        stateToReturn = stateToReturn.merge({itemsQuantityMap})
    }


    let selectedServiceCategory = state.stateParams.s_category;
    if (isNonEmptyString(selectedServiceCategory) && config.ServiceCategories) {
        if (config.ServiceCategories.find((x) => x.value.toString() === selectedServiceCategory)) {
            let serviceCategory = parseInt(selectedServiceCategory);
            stateToReturn = stateToReturn.merge({
                serviceCategory,
                filteredAvailableServices: filterServicesByCategory(state, serviceCategory)
            })
        }

    }

    return stateToReturn;
};


/* ------------- Reducers ------------- */
export const stateParamsRequest = (state, {
    token,
    mobile,
    email,
    service_id,
    employee_id,
    day_part = DEFAULT_DAY_PART,
    date,
    validation_hash,
    existing_mode,
    quantities,
    gender,
    s_category,
    s_token
}) => {
    return state.merge({
        stateParams: {
            token,
            mobile,
            email,
            service_id, employee_id, day_part, date,
            validation_hash,
            existing_mode,
            quantities,
            gender,
            s_category,
            s_token
        }
    })
};

/**
 * The url is optional: most callers only know the token. Merging it unconditionally used to wipe a
 * url that was already known, which unmounted the payment iframe and mounted it again once the url
 * came back - loading the payment page twice and taking the same link on both loads.
 */
const setSessionToken = (state, {s_token, paymentUrl}) => state.merge({
    ...(paymentUrl === undefined ? {} : {paymentUrl}),
    stateParams: {s_token}
});

export const requestConfig = (state) =>
    state.merge({fetchingConfig: true, config: null});

export const successConfig = (state, {config}) => {
    let updatedStateParams = state.stateParams.merge({token: config.Token});
    let existingMode = extractExistingMeetingsAndSetMode(updatedStateParams.existing_mode, config);

    return adaptServiceAndEmployeeToState(state.merge({
        fetchingConfig: false,
        errorWithConfig: null,
        allowAdditionalMeetings: config.EnableSettingAnotherMeeting,
        config,
        existingMode,
        hasOtherMeetings: !existingMode && isNonEmptyObject(config.GroupedNextMeetings),
        timingOptions: state.timingOptions || TIMING_FRAMES.slice(),
        stateParams: updatedStateParams,
        progress: convertProgress(state, config),
    }), config);
}


export const failureConfig = (state, {error}) => {
    return state.merge({fetchingConfig: false, errorWithConfig: error, config: null});
};


/// WITH SERVICES!

// Anything not asking otherwise keeps the old behaviour of starting from nothing.
export const requestConfigWithServices = (state, {clearExisting = true} = {}) =>
    state.merge(clearExisting ? {fetchingServices: true, configWithServices: null} : {fetchingServices: true});

export const successConfigWithServices = (state, {config}) => {
    const progress = configToProgress(config, state.paymentType)

    config.ImageBase64 = state.config ? state.config.ImageBase64 : null;
    let updatedTimingOptions = state.timingOptions || TIMING_FRAMES.slice();
    if (config.AvailibilitiesValidParts && config.AvailibilitiesValidParts !== '111') {
        updatedTimingOptions = config.AvailibilitiesValidParts.split('').slice(0, 3).reduce((acc, curr, idx) =>
            curr === '1' ? acc.concat(TIMING_FRAMES[idx]) : acc, [])
    }

    let nextExistingMeetings = config.GroupedNextMeetings;
    let existingMode = extractExistingMeetingsAndSetMode(state.existing_mode, config);

    const toReturn = adaptServiceAndEmployeeToState(state.merge({
        fetchingServices: false,
        errorWithServices: null,
        allowAdditionalMeetings: config.EnableSettingAnotherMeeting,
        configWithServices: config,
        config: config,
        nextExistingMeetings,
        hasOtherMeetings: !existingMode && isNonEmptyObject(nextExistingMeetings),
        progress,
        timingOptions: updatedTimingOptions,
        stateParams: state.stateParams.merge({
            day_part: config.AvailibilitiesValidParts || config.day_part,
            token: config.Token
        }),
        waitingListSelectedDaysOfWeek: config.DaysOfWork.slice(),
        daysOfWork: config.DaysOfWork.slice()
    }), config);

    const updatedProgress = convertProgress(toReturn, config);
    return toReturn.merge({progress: updatedProgress});
};

const convertProgress = (state, config) => {
    let progress;
    if (config.Customer) {
        const name = `${config.Customer.FirstName}${config.Customer.LastName ? ' ' + config.Customer.LastName : ''}`;
        progress = setProgressValueByKey(state, PROGRESS_KEY.IDENTIFY, name, null, config);
    } else {
        progress = setProgressValueByKey(state, null, null, null, config);
    }

    return progress;
}

export const failureConfigWithServices = (state, {error}) =>
    state.merge({fetchingServices: false, errorWithServices: error, configWithServices: null});


export const setServices = (state, {services}) => {
    const serviceValue = services.map(s => s.ServiceRepresentativeName).join(', ')
    const progress = setProgressValueByKey(state, PROGRESS_KEY.SERVICE, serviceValue);
    let availableEmployees = null;
    let itemsQuantityMap = asMutable(state.itemsQuantityMap)
    if (services && services[0] && services[0].Employees) {
        const allRequestedGenders = Object.keys(valueOrDefault(state.itemsGenderMap, {})).reduce((acc, serviceId) => {
            state.itemsGenderMap[serviceId].forEach((gender) => acc.add(gender));
            return acc;
        }, new Set());

        let filterEmployees = services[0].Employees;

        if (allRequestedGenders.size === 1) {
            let requestedGender = allRequestedGenders.values().next().value;
            filterEmployees = filterEmployees.filter((employee) => isGenderMatch(requestedGender, employee.Gender))
        }

        const availableEmployeesMap = filterEmployees.reduce((acc, employee) => ({
            ...acc,
            [employee.EmployeeId]: employee
        }), {});

        let employeeIdsKeys = Object.keys(availableEmployeesMap).map(id => parseInt(id));
        services.slice(1).map(service => service.Employees ? service.Employees.map(e => e.EmployeeId) : []).forEach(employeeIds => {
            employeeIdsKeys = employeeIdsKeys.filter(v => -1 !== employeeIds.indexOf(v))
        });

        availableEmployees = (!state.config.ForcePickingEmployees ? [{...ANY_EMPLOYEE}] : []).concat(employeeIdsKeys.map(key => availableEmployeesMap[key]));
        const selectedServices = services.map((service) => service.OnlineBookingServiceId)
        Object.keys(itemsQuantityMap).forEach((serviceId) => {
            if (!selectedServices.includes(parseInt(serviceId))) {
                delete itemsQuantityMap[serviceId]
            }
        })

    } else {
        itemsQuantityMap = {}
    }

    return state.merge({
        services,
        availableEmployees,
        progress,
        itemsQuantityMap,
        stateParams: state.stateParams.merge({service_id: services.map(s => s.OnlineBookingServiceId).join(',')})
    });
};

export const setEmployee = (state, {employee}) => {
    const name = `${employee.FirstName}${employee.LastName ? ' ' + employee.LastName : ''}`;
    const progress = setProgressValueByKey(state, PROGRESS_KEY.EMPLOYEE, name, employee?.translateName);

    return state.merge({
        employee,
        progress,
        stateParams: state.stateParams.merge({employee_id: employee.EmployeeId})
    });
};

export const toggleDayPart = (state, {option}) => {
    const options = state.timingOptions.asMutable();
    let indexOfOption = 0;
    for (let idx in options) {
        if (options[idx].value === option.value) {
            indexOfOption = idx;
            break;
        }
    }

    options[indexOfOption] = options[indexOfOption].set('checked', !option.checked);
    return state.merge({
        timingOptions: options,
        stateParams: state.stateParams.merge({day_part: options.map(option => option.checked ? '1' : '0').join('')})
    });
};


export const alignDayParts = (state, {dayParts}) => {
    let options = state.timingOptions.asMutable();
    dayParts.split('').forEach((dayPart, idx) => {
        if (options.length > idx) {
            options[idx] = options[idx].set('checked', dayPart === '1')
        }
    });

    return state.merge({
        timingOptions: options,
        stateParams: state.stateParams.merge({day_part: dayParts})
    });
};


export const setDateOption = (state, {option}) => {
    let valueToSet = 'schedule.asap';
    if (option !== 'asap') {
        valueToSet = serverDayDate(Moment(option));
    }

    const progress = setProgressValueByKey(state, PROGRESS_KEY.TIME_ALIGNMENT, valueToSet, option === ASAP_DATE.value && ASAP_DATE.label);
    return state.merge({
        stateParams: state.stateParams.merge({date: option}),
        progress: progress,
        fetchingSpecificOptions: false,
        errorSpecificOptions: null,
        specificOptions: null

    });
};

/**** INSTANT OPTIONS ****/

export const requestInstantOptions = (state) =>
    state.merge({fetchingInstantOptions: true});

export const successInstantOptions = (state, {options}) => {
    return state.merge({
        fetchingInstantOptions: false,
        errorInstantOptions: null,
        instantOptions: options
    });
};

export const failureInstantOptions = (state, {error}) =>
    state.merge({fetchingInstantOptions: false, errorInstantOptions: error, instantOptions: null});

export const clearOptionsError = (state) =>
    state.merge({errorInstantOptions: null});


/**** SPECIFIC OPTIONS ****/


export const requestSpecificOptions = (state) => {
    const selectedDate = state.stateParams.date;
    let asapMode = selectedDate === ASAP;
    const waitingListSelectedDate = !asapMode ? Moment(selectedDate).toDate() : new Date();
    const waitingListRangeType = asapMode ? WAITING_LIST_RANGE_MODE.WEEK_DAYS : WAITING_LIST_RANGE_MODE.EXACT_DATE;

    return state.merge({fetchingSpecificOptions: true, waitingListSelectedDate, waitingListRangeType});
}


export const successSpecificOptions = (state, {options, loadMore}) => {
    let adaptedOptions = options;
    if (Array.isArray(options)) {
        adaptedOptions = {
            availableAppointments: options,
            userSelection: null
        }
    }

    const {availableAppointments, userSelection, waitingListMode} = adaptedOptions;


    return state.merge({
        fetchingSpecificOptions: false,
        errorSpecificOptions: null,
        specificOptions: loadMore ? state.specificOptions.asMutable().concat(availableAppointments) : availableAppointments,
        userSelection,
        waitingListMode
    });
};

export const failureSpecificOptions = (state, {error}) => state.merge({
    fetchingSpecificOptions: false,
    errorSpecificOptions: error,
    specificOptions: null
});

/**** SCHEDULE OPTIONS ****/

export const requestSchedule = (state) =>
    state.merge({schedulingMeetings: true});

export const successSchedule = (state, {scheduledMeetings, paymentRequired, url, icsUrl, paymentType}) => {
    return state.merge({
        paymentRequired: !!paymentRequired,
        schedulingMeetings: false,
        scheduledMeetings,
        paymentUrl: url,
        paymentType,
        icsUrl,
        schedulingMeetingsError: null,
        progress: configToProgress(state.config, paymentType)
    });
};

export const failureSchedule = (state, {error}) => state.merge({
    schedulingMeetings: false,
    scheduledMeetings: null,
    schedulingMeetingsError: error
});


export const successSendValidatePhone = (state, {validationHash, mobile, email}) => {
    return state.merge({
        stateParams: state.stateParams.merge({validation_hash: validationHash, mobile, email}),
    });
};


export const replaceToken = (state, {updatedToken}) => {
    return INITIAL_STATE.merge({
        stateParams: {token: updatedToken}
    })
};

export const resetWizard = (state) => {
    return INITIAL_STATE.merge({
        stateParams: {token: state.stateParams.token}
    })
};

const setExistingMeetingsGroupMode = (state, {mode, group}) => {
    let meetings = [];

    if (group) {
        meetings = group.meetings.map(({MeetingId, StartTime}) => ({
            MeetingId,
            StartTime: genericDateTime(StartTime)
        }));

        if (group.employeeToSet) {
            state = setEmployee(state, {employee: group.employeeToSet})
        }

        if (group.servicesToSet) {
            state = setServices(state, {services: group.servicesToSet});
        }
    }

    const existingMode = {
        mode,
        meetings
    }

    return state.merge({
        existingMode: existingMode,
        hasOtherMeetings: state.hasOtherMeetings && existingMode.meetings.length === 0 && !existingMode.mode,
        stateParams: state.stateParams.merge({
            existing_mode: JSON.stringify(existingMode),
        })
    });
}

const clearExistingMeetingsMode = (state) => {
    if (!state.config) {
        return state;
    }

    let nextExistingMeetings = state.config.GroupedNextMeetings;
    return state.merge({
        existingMode: undefined,
        hasOtherMeetings: isNonEmptyObject(nextExistingMeetings),
        nextExistingMeetings,
        stateParams: !state.stateParams ? undefined : state.stateParams.merge({
            existing_mode: undefined
        })
    });
}


///
/// We make sure the existing meetings that were found on the url actually match existing meetings...
const extractExistingMeetingsAndSetMode = (stringExistingMode, config) => {
    if (!stringExistingMode || !config) {
        return null;
    }

    let existingMode;
    try {
        existingMode = JSON.parse(stringExistingMode)
    } catch (e) {
        return null
    }

    if (existingMode.mode === 'removed') {
        return existingMode;
    }

    /// We parse the date ourselves since it's generic and not server date.
    if (!isSameDate(existingMode.meetings.map(x => Moment(x.StartTime)))) {
        return null;
    }

    const existingIdToTimeMap = existingMode.meetings.reduce((acc, meeting) => ({
        ...acc,
        [meeting.MeetingId]: toServerDate(meeting.StartTime)
    }), {})

    config.NextMeetings.forEach(meeting => {
        if (existingIdToTimeMap[meeting.MeetingId] === meeting.StartTime) {
            delete existingIdToTimeMap[meeting.MeetingId];
        }
    })


    /// That's good! it means there is a match!
    if (Object.keys(existingIdToTimeMap).length === 0) {
        return existingMode;
    }

    return null;
};


/**** REMOVE MEETING ****/

export const requestRemove = (state) =>
    state.merge({removingMeeting: true});

export const successRemove = (state) => {
    let existingMode = {
        mode: 'removed'
    }

    return state.merge({
        removingMeeting: false,
        meetingRemoved: true,
        removedMeetingError: null,
        hasOtherMeetings: false,
        existingMode,
        stateParams: state.stateParams.merge({
            existing_mode: JSON.stringify(existingMode),
        })
    });
};

export const failureRemove = (state, {error}) => state.merge({
    removingMeeting: false,
    meetingRemoved: false,
    removedMeetingError: error
});

/**** QUANTITY *****/

const changeItemQuantity = (state, {item, addition, simultaneousType}) => {
    let updatedQuantity = undefined;
    let itemsQuantityMap = state.itemsQuantityMap.asMutable({deep: true});
    const currentQuantity = itemsQuantityMap[item.OnlineBookingServiceId];
    const wasSimultaneousTypeSet = isNonEmptyString(item.SimultaneousServicesSchedulingType) && item.SimultaneousServicesSchedulingType !== SIMULTANEOUS_SERVICE_SCHEDULING_TYPE.BOTH;


    let [currentQuantityNumber, currentSimultaneousType] = isNonEmptyString(currentQuantity) ? currentQuantity.split('_') : ['1',
        wasSimultaneousTypeSet ? item.SimultaneousServicesSchedulingType : SIMULTANEOUS_SERVICE_SCHEDULING_TYPE.PARALLEL
    ];

    currentQuantityNumber = parseInt(currentQuantityNumber);


    if (isConcreteValue(addition)) {
        currentQuantityNumber += (addition ? 1 : -1);
    } else if (!isConcreteValue(simultaneousType)) {
        currentQuantityNumber = undefined;
    }

    if (currentQuantityNumber > 0) {
        updatedQuantity = `${currentQuantityNumber}_${simultaneousType || currentSimultaneousType}`;
    }

    itemsQuantityMap[item.OnlineBookingServiceId] = updatedQuantity;

    const quantities = Object.keys(itemsQuantityMap).reduce((acc, key) => {
        let currentQuantity = parseInt((itemsQuantityMap[key] || '0').split('_')[0]);
        if (currentQuantity > 0) {
            return [...acc, `${key}_${itemsQuantityMap[key]}`];
        }

        return acc;
    }, []).join(',')

    return state.merge({
        itemsQuantityMap: cleanObj(itemsQuantityMap),
        stateParams: state.stateParams.merge({quantities: isNonEmptyString(quantities) ? quantities : undefined})
    });
}

const changeItemGender = (state, {item, genders}) => {
    let itemsGenderMap = state.itemsGenderMap.asMutable({deep: true});
    itemsGenderMap[item.OnlineBookingServiceId] = (isNonEmptyArray(genders) && genders.some((x) => x !== GENDER_TYPE.ANY)) ? genders : null;
    const asStateParam = Object.keys(cleanObj(itemsGenderMap)).map((key) => {
        return `${key}_${itemsGenderMap[key].join('-')}`;
    }).join(',');

    return state.merge({
        itemsGenderMap: cleanObj(itemsGenderMap),
        stateParams: state.stateParams.merge({gender: isNonEmptyString(asStateParam) ? asStateParam : undefined})
    });
}

const selectServiceCategory = (state, {category}) => {
    let serviceCategory = category.value;
    return state.merge({
        serviceCategory,
        filteredAvailableServices: filterServicesByCategory(state, category.value),
        stateParams: state.stateParams.merge({s_category: isNumber(serviceCategory) ? serviceCategory : undefined})

    })
}

const filterServicesByCategory = (state, serviceCategory) => {
    if (!isConcreteValue(serviceCategory)) {
        return state.config.Services;
    }

    const selectedServicesId = valueOrDefault(state.services, []).map((x) => x.OnlineBookingServiceId);
    let filteredAvailableServices = state.config.Services.filter((service) => {
        return service.categoryIds.includes(serviceCategory) || selectedServicesId.includes(service.OnlineBookingServiceId);
    });

    filteredAvailableServices = JSON.parse(JSON.stringify(filteredAvailableServices));
    filteredAvailableServices = filteredAvailableServices.sort((a, b) => {
        const aIsSelected = selectedServicesId.includes(a.OnlineBookingServiceId);
        const bIsSelected = selectedServicesId.includes(b.OnlineBookingServiceId);
        if (aIsSelected && !bIsSelected) {
            return -1;
        }

        return 0;
    });

    return filteredAvailableServices;

}

/* ------------- SESSION ------------- */


export const sessionRequest = (state) =>
    state.merge({requestingSession: true, sessionError: null});

export const sessionSuccess = (state, {
    scheduledMeetings,
    url,
    paymentRequired,
    progressValues,
    expiresOn,
    paymentType
}) => {
    return state.merge({
        requestingSession: false,
        sessionError: null,
        scheduledMeetings,
        paymentUrl: url,
        paymentExpiresOn: expiresOn,
        paymentType,
        paymentRequired,
        progress: progressValues
    });
};

export const sessionFailure = (state, {error}) => state.merge({
    sessionError: error,
    requestingSession: false,
});


export const cancelSessionRequest = (state) =>
    state.merge({cancelingSession: true, cancelSessionError: null});

export const cancelSessionSuccess = (state) => {
    return state.merge({
        cancelingSession: false,
        cancelSessionError: null,
        stateParams: {
            s_token: null
        }
    });
};

export const cancelSessionFailure = (state, {error}) => state.merge({
    cancelSessionError: error,
    cancelingSession: false,
});


/* ------------- Hookup Reducers To Types ------------- */

/* ------------- MANIFEST ------------- */


export const manifestRequest = (state) =>
    state.merge({requestingManifest: true, manifestError: null});

export const manifestSuccess = (state, {manifest}) => {
    return state.merge({
        requestingManifest: false, manifestError: null, manifest
    });
};

export const manifestFailure = (state, {error}) => state.merge({
    requestingManifest: false, manifestError: error, manifest: null
});

/**
 * WAITING LIST REGISTERATION.
 */

export const registerWaitingListRequest = (state) =>
    state.merge({registeringWaitingList: true, registeringWaitingListError: null, waitingListItem: null});

export const registerWaitingListSuccess = (state, {waitingListItem}) => {
    return state.merge({
        registeringWaitingList: false,
        registeringWaitingListError: null,
        waitingListItem,
        waitingListMode: null
    });
};

export const registerWaitingListError = (state, {error}) => state.merge({
    registeringWaitingList: false,
    registeringWaitingListError: error,
    waitingListItem: null,
});

export const removeWaitingListSuccess = (state) => {
    const config = {...state.config || {}, WaitingListItem: null};
    const configWithServices = {...state.configWithServices || {}, WaitingListItem: null};
    return state.merge({
        config,
        configWithServices
    });
}


export const reducer = createReducer(INITIAL_STATE, {
    [Types.SET_STATE_PARAMS]: stateParamsRequest,
    [Types.CONFIG_REQUEST]: requestConfig,
    [Types.CONFIG_SUCCESS]: successConfig,
    [Types.CONFIG_ERROR]: failureConfig,
    [Types.CONFIG_WITH_SERVICES_REQUEST]: requestConfigWithServices,
    [Types.CONFIG_WITH_SERVICES_SUCCESS]: successConfigWithServices,
    [Types.CONFIG_WITH_SERVICES_ERROR]: failureConfigWithServices,
    [Types.SET_SERVICES]: setServices,
    [Types.SET_EMPLOYEE]: setEmployee,
    [Types.TOGGLE_DAY_PART]: toggleDayPart,
    [Types.SET_DATE_OPTION]: setDateOption,
    [Types.INSTANT_OPTIONS_REQUEST]: requestInstantOptions,
    [Types.INSTANT_OPTIONS_SUCCESS]: successInstantOptions,
    [Types.INSTANT_OPTIONS_ERROR]: failureInstantOptions,
    [Types.SPECIFIC_OPTIONS_REQUEST]: requestSpecificOptions,
    [Types.SPECIFIC_OPTIONS_SUCCESS]: successSpecificOptions,
    [Types.SPECIFIC_OPTIONS_ERROR]: failureSpecificOptions,
    [Types.OPTIONS_ERROR_CLEAR]: clearOptionsError,
    [Types.ALIGN_DAY_PARTS]: alignDayParts,
    // SCHEDULE:
    [Types.SCHEDULE_MEETING_REQUEST]: requestSchedule,
    [Types.SCHEDULE_MEETING_SUCCESS]: successSchedule,
    [Types.SCHEDULE_MEETING_ERROR]: failureSchedule,
    // REMOVE:
    [Types.REMOVE_MEETINGS_REQUEST]: requestRemove,
    [Types.REMOVE_MEETINGS_SUCCESS]: successRemove,
    [Types.REMOVE_MEETINGS_ERROR]: failureRemove,
    // SESSION:
    [Types.GET_SESSION_REQUEST]: sessionRequest,
    [Types.GET_SESSION_SUCCESS]: sessionSuccess,
    [Types.GET_SESSION_ERROR]: sessionFailure,
    [Types.CANCEL_SESSION_REQUEST]: cancelSessionRequest,
    [Types.CANCEL_SESSION_SUCCESS]: cancelSessionSuccess,
    [Types.CANCEL_SESSION_ERROR]: cancelSessionFailure,
    // RESET
    [CommonTypes.WIZARD_RESET]: resetWizard,
    // VALIDATATION HASH:
    [IdentifyTypes.SEND_VALIDATE_PHONE_SUCCESS]: successSendValidatePhone,
    // REPLACE TOKEN:
    [IdentifyTypes.REPLACE_TOKEN]: replaceToken,
    // EXISTING MODE:
    [Types.SET_EXISTING_MEETINGS_GROUP_MODE]: setExistingMeetingsGroupMode,
    [Types.CLEAR_EXISTING_MEETINGS_MODE]: clearExistingMeetingsMode,
    // QUANTITY:
    [Types.CHANGE_ITEM_QUANTITY]: changeItemQuantity,
    [Types.CHANGE_ITEM_GENDER]: changeItemGender,
    // Service Category:
    [Types.SELECT_SERVICE_CATEGORY]: selectServiceCategory,
    // Session Token
    [Types.SET_SESSION]: setSessionToken,
    // Manifest
    [Types.GET_MANIFEST_REQUEST]: manifestRequest,
    [Types.GET_MANIFEST_SUCCESS]: manifestSuccess,
    [Types.GET_MANIFEST_ERROR]: manifestFailure,
    // WAITING LIST
    [Types.SET_WAITING_LIST_SELECTED_DATE]: (state, {selectedDate}) => state.merge({waitingListSelectedDate: selectedDate}),
    [Types.SET_WAITING_LIST_RANGE_TYPE]: (state, {rangeType}) => state.merge({waitingListRangeType: rangeType}),
    [Types.SET_WAITING_LIST_SELECTED_DAYS_OF_WEEK]: (state, {daysOfWeek}) => state.merge({waitingListSelectedDaysOfWeek: daysOfWeek}),
    [Types.REGISTER_WAITING_LIST_REQUEST]: registerWaitingListRequest,
    [Types.REGISTER_WAITING_LIST_SUCCESS]: registerWaitingListSuccess,
    [Types.REGISTER_WAITING_LIST_ERROR]: registerWaitingListError,
    [Types.REMOVE_WAITING_LIST_SUCCESS]: removeWaitingListSuccess,
    [Types.SET_IGNORE_WAITING_LIST]: (state) => state.merge({ignoreWaitingList: true}),


});
